import React, { useEffect } from "react"
import { gsap } from "gsap";

const PageTransition = ({ internal }) => {

  useEffect(() => { 
    gsap.fromTo('main', {y:-30}, { opacity: 1, y:0, duration: 1, ease: "power3.inOut" });
  }, [internal]);

  return (
    <></>
  )
}
export default PageTransition